import { HistoryService } from 'web_core_library';
import ENV from './env';

const getCheckoutSearchParams = (productId: number, lang: string, country?: string, coupon?: string) => {
  const searchParams = HistoryService.getCurrentSearchParams();
  searchParams.set('productId', `${productId}`);
  searchParams.set('lang', lang);
  if (country) {
    searchParams.set('country', country);
  }
  if (coupon) {
    searchParams.set('coupon', coupon);
  } else {
    // we need to remove coupon if its present in the url but not applicable to given product
    searchParams.delete('coupon');
  }
  return searchParams.toString();
};

export function getFullLocalUrl(path = '', search?: string) {
  const basePath = ENV.BasePath;
  const relativePath = path.startsWith('/') ? path : `/${path}`;
  const searchParams = search ? `/?${search}` : '';
  return `${basePath}${relativePath}${searchParams}`;
}

const getCheckoutUrl = (planId: string, productId: number, lang: string, country?: string, coupon?: string) => {
  const search = getCheckoutSearchParams(productId, lang, country, coupon);
  return getFullLocalUrl(`/checkout/${planId}`, search);
};

export const getCheckoutBackUrl = (
  planId: string,
  productId: number,
  lang: string,
  country?: string,
  coupon?: string
) => {
  const internalHref = getCheckoutUrl(planId, productId, lang, country, coupon);
  const backUrl = new URL(internalHref, window.location.origin);
  return HistoryService.getNormalizedUrl(backUrl);
};

export function isSubscribe(path: string) {
  const isSubscribe = path === '/' || /subscribe|cb|checkout/i.test(path);
  return isSubscribe;
}

export function isCustomObFlowActive() {
  const searchParams = HistoryService.getCurrentSearchParams();
  const obValueStr = searchParams.get('ob_flow');
  return obValueStr !== null;
}

export const getProductIdFromUrl = () => {
  const searchParams = HistoryService.getCurrentSearchParams();
  const productId = searchParams.get('productId');
  if (!productId) {
    return;
  }
  return productId;
};

export const getCountryCodeFromUrl = () => {
  const searchParams = HistoryService.getCurrentSearchParams();
  const country = searchParams.get('country');
  if (!country) {
    return;
  }
  return country;
};

export const redirectBackToSubscribe = (cb?: boolean) => {
  // BW-6866: preserve existing search parameters to keep ob_flow if it is set
  const searchParams = HistoryService.getCurrentSearchParams();
  const search = searchParams.toString();
  const path = cb ? '/cb/' : '/';
  const internalHref = `${path}`;
  HistoryService.redirectInternal(internalHref, undefined, search);
};

export const getPrivacyPolicyUrl = (lang: string) => {
  return HistoryService.getExternalUrl(ENV.PrivacyPolicyUrl, lang);
};

export const redirectToCheckout = (
  planId: string,
  productId: number,
  lang: string,
  country?: string,
  coupon?: string
) => {
  const search = getCheckoutSearchParams(productId, lang, country, coupon);
  const internalHref = `/checkout/${planId}/`;
  HistoryService.redirectInternal(internalHref, undefined, search);
};

export const redirectToManage = () => {
  const internalHref = '/manage/';
  HistoryService.redirectInternal(internalHref);
};

export const redirectToCheckoutSuccess = () => {
  // BW-6866: preserve existing search parameters to keep ob_flow if it is set
  const searchParams = HistoryService.getCurrentSearchParams();
  const search = searchParams.toString();
  const internalHref = `/checkout/success/`;
  HistoryService.redirectInternal(internalHref, undefined, search);
};

export const redirectToCheckoutCancel = () => {
  // BW-6866: preserve existing search parameters to keep ob_flow if it is set
  const searchParams = HistoryService.getCurrentSearchParams();
  const search = searchParams.toString();
  const internalHref = `/checkout/cancel/`;
  HistoryService.redirectInternal(internalHref, undefined, search);
};

export const redirectToCheckoutError = () => {
  // BW-6866: preserve existing search parameters to keep ob_flow if it is set
  const searchParams = HistoryService.getCurrentSearchParams();
  const search = searchParams.toString();
  const internalHref = `/checkout/error/`;
  HistoryService.redirectInternal(internalHref, undefined, search);
};
